// Gestionar ubicación compras
import FrmManageShoppingLocationIndex from '@/pages/warehouse/manageShoppingLocation/FrmManageShoppingLocationIndex.vue';
import FrmManageShoppingLocationDetails from '@/pages/warehouse/manageShoppingLocation/FrmManageShoppingLocationDetails.vue';

// Gestionar ubicación ventas
import FrmManageSalesLocationIndex from '@/pages/warehouse/manageSalesLocation/FrmManageSalesLocationIndex.vue';
import FrmManageSalesLocationDetails from '@/pages/warehouse/manageSalesLocation/FrmManageSalesLocationDetails.vue';

// Recuento y regularización de inventario
import FrmInventoryRegularizationHome from '@/pages/warehouse/inventoryRegularization/FrmInventoryRegularizationHome.vue';
import FrmInventoryRegularizationAndCount from '@/pages/warehouse/inventoryRegularization/FrmInventoryRegularizationAndCount.vue';

// Movimiento de mercancías entre almacenes
import FrmManageItemLocationHome from '@/pages/warehouse/manageItemLocation/FrmManageItemLocationHome.vue';

export default [
  {
    path: '/warehouse/manageShoppingLocation/frmManageShoppingLocation',
    component: FrmManageShoppingLocationIndex,
  },
  {
    path: '/warehouse/manageShoppingLocation/frmManageShoppingLocationDetails',
    component: FrmManageShoppingLocationDetails,
  },
  {
    path: '/warehouse/manageSalesLocation/frmManageSalesLocation',
    component: FrmManageSalesLocationIndex,
  },
  {
    path: '/warehouse/manageSalesLocation/frmManageSalesLocationDetails',
    component: FrmManageSalesLocationDetails,
  },
  {
    path: '/warehouse/inventoryRegularization/frmInventoryRegularization',
    component: FrmInventoryRegularizationHome,
  },
  {
    path: '/warehouse/inventoryRegularization/frmInventoryRegularizationAndCount',
    component: FrmInventoryRegularizationAndCount,
  },
  {
    path: '/warehouse/manageItemLocation/frmManageItemLocation',
    component: FrmManageItemLocationHome,
  },
];
